import React from "react";
import { Navigate, RouteObject } from "react-router-dom";

import {
  EXPERIMENT_ROUTES,
  GENERAL_ROUTES,
  OLD_EXPERIMENT_ROUTES,
} from "../../routes";

// Legacy test paths that should redirect to the all-experiences table. The
// *_Id test paths use optional params (e.g. "/content-test/:id?"), so they
// also match the bare path — no separate entry needed for those.
const LEGACY_REDIRECT_PATHS = [
  OLD_EXPERIMENT_ROUTES.Compare,
  OLD_EXPERIMENT_ROUTES.Compare_Id,
  OLD_EXPERIMENT_ROUTES.ContentTest_Id,
  OLD_EXPERIMENT_ROUTES.PriceTest_Id,
  OLD_EXPERIMENT_ROUTES.ShippingTest_Id,
  OLD_EXPERIMENT_ROUTES.OfferTest_Id,
  OLD_EXPERIMENT_ROUTES.DuplicateProducts,
  OLD_EXPERIMENT_ROUTES.DuplicateProducts_Id,
];

export const ExperimentRoutes: RouteObject[] = [
  // Legacy tests list → home (all-experiences table)
  {
    path: EXPERIMENT_ROUTES.Experiments,
    element: <Navigate to={GENERAL_ROUTES.Index} replace />,
  },
  ...LEGACY_REDIRECT_PATHS.map((path) => ({
    path,
    element: <Navigate to={GENERAL_ROUTES.Index} replace />,
  })),
];
